// extracted by mini-css-extract-plugin
export var grid = "_h-0";
export var span1 = "_h-2";
export var span10 = "_h-b";
export var span10L = "_h-z";
export var span10M = "_h-n";
export var span10Xl = "_h-1b";
export var span11 = "_h-c";
export var span11L = "_h-10";
export var span11M = "_h-o";
export var span11Xl = "_h-1c";
export var span12 = "_h-d";
export var span12L = "_h-11";
export var span12M = "_h-p";
export var span12Xl = "_h-1d";
export var span1L = "_h-q";
export var span1M = "_h-e";
export var span1Xl = "_h-12";
export var span2 = "_h-3";
export var span2L = "_h-r";
export var span2M = "_h-f";
export var span2Xl = "_h-13";
export var span3 = "_h-4";
export var span3L = "_h-s";
export var span3M = "_h-g";
export var span3Xl = "_h-14";
export var span4 = "_h-5";
export var span4L = "_h-t";
export var span4M = "_h-h";
export var span4Xl = "_h-15";
export var span5 = "_h-6";
export var span5L = "_h-u";
export var span5M = "_h-i";
export var span5Xl = "_h-16";
export var span6 = "_h-7";
export var span6L = "_h-v";
export var span6M = "_h-j";
export var span6Xl = "_h-17";
export var span7 = "_h-8";
export var span7L = "_h-w";
export var span7M = "_h-k";
export var span7Xl = "_h-18";
export var span8 = "_h-9";
export var span8L = "_h-x";
export var span8M = "_h-l";
export var span8Xl = "_h-19";
export var span9 = "_h-a";
export var span9L = "_h-y";
export var span9M = "_h-m";
export var span9Xl = "_h-1a";
export var stretch = "_h-1";